export default function (Component) {
Component.options.__tip = "<p>Form items can be inlined. You can do this either by setting the <code>inline</code>-flag on each item or by simply setting it on the enclosing <code>FdFormGroup</code>.</p>\n"
}